import Vue from 'vue'
import Router from 'vue-router' 
import Login from '@/views/Login/login' // 登录页面
import Enterprise from '@/views/EnterIndex/enterIndexDefault/index' // 企业端首页
import Redirect from '@/views/Redirect/index' // 路由重定向

Vue.use(Router)

/* 初始路由 */
export const routes = [{
  path: '/login',
  name: 'Login',
  component: Login,
	meta: {
		title: '登录页面'
	}
},{
	path: '/enter',
	name: 'Enterprise',
	component: Enterprise,
	meta: {
		title: '企业端首页'
	}
},{
	path: '/redirect',
	name: 'redirect',
	component: Redirect
}]

const createRouter = () => new Router({
  routes: routes
})

const router = createRouter()

// 重置路由
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router 



// WEBPACK FOOTER //
// ./src/router/index.js